import React from 'react'
import AppModal from '../common/AppModal'
import CreateOrUpdateCompanyChargeForm from '../../forms/CreateOrUpdateCompanyChargeForm'

interface CreateCompanyChargeModalProps {
  open: boolean
  onClose: () => void
  loading: boolean
  error: string | null
}

const CreateCompanyChargeModal: React.FC<CreateCompanyChargeModalProps> = ({
  open,
  onClose,
  loading,
  error
}) => (
  <AppModal open={open} onClose={onClose} title="Add Company Charge" width="sm" loading={loading}>
    <CreateOrUpdateCompanyChargeForm loading={loading} error={error} />
  </AppModal>
)

export default CreateCompanyChargeModal
